import { render, staticRenderFns } from "./ListSamplesProduction.vue?vue&type=template&id=f7fd15e8"
import script from "./ListSamplesProduction.vue?vue&type=script&lang=js"
export * from "./ListSamplesProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports